// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-sub-menu-flyout-item {
  display: flex;
  gap: calc(.5rem);
  width: 100%;
  padding: calc(.5rem);
  color: #424242;
  border-radius: 0.25rem;
}

  .help-sub-menu-flyout-item:hover,
  .help-sub-menu-flyout-item.hover {
    background-color: #f6f7f8;
  }

  .help-sub-menu-flyout-item:active,
  .help-sub-menu-flyout-item.active {
    outline: none;
    background-color: #e5e6e6;
  }

  .help-sub-menu-flyout-item:focus,
  .help-sub-menu-flyout-item.focus {
    outline: 1px solid #206dd2;
    background-color: #fff;
  }

  .help-sub-menu-flyout-item__badge-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 25px;
  }

  .help-sub-menu-flyout-item__detail {
    font-size: 0.75rem;
    line-height: 1.125rem;
  }

  .help-sub-menu-flyout-item__title {
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.375rem;
  }

  .help-sub-menu-flyout-item__description:hover {
    cursor: pointer;
  }

a {
  color: inherit;
  -webkit-text-decoration: none;
  text-decoration: none;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
